<style lang="scss" scoped>
@import 'common/sass/reuse.SCSS';
</style>

<template>
  <div class="maintenance-box">
    <div class="panel" v-loading="loading">
        <custom-table
            :page="page"
            :selPage="selPage"
            :tableHead="tableHead"
            :tbodyData="tbodyData"
            @tableChange="pageHandle"
        >
            <div class="search-box" slot="search">
                <div class="select-type">
                    <el-input v-model="searchVal">
                        <el-select slot="prepend" v-model="searchKey" style="width:110px;">
                            <template v-for="(k,v) in language.searchKeys">
                                <el-option :label="k" :value="v" :key="v"></el-option>
                            </template>
                        </el-select>
                        <el-button slot="append" @click="ajaxHandle">{{reuse.searchText}}</el-button>
                    </el-input>
                </div>
                <div class="select-type">
                    <div @click="export2Excel" class="btn btn-default">
                    <i class="glyphicon glyphicon-save tab-he-glyphicon"></i>
                    {{reuse.downloadExcelForms}}
                    </div>
                </div>
            </div>
        </custom-table>
    </div>
  </div>
</template>

<script>
import customTable from 'components/reuseTable'
import { URL_LOGIN_RECORD } from 'api/api'

const data = () => {
  return {
    tbodyData: [],
    allData: [],
    searchVal: null,
    searchKey: 'ip',
    loading: false,
    validKeys: {
        ip: /^((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})(\.((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})){3}$/,
        login: /^[1-9]\d{0,11}$/,
    },
    page: {
      active: 1,
      pageLeng: 0,
      offset: 0
    },
    selPage: {
      list: ['5', '10', '25', '50'],
      active: 1,
      limit: 10
    },
  }
}

const mixins = [
    require('common/mixin/base').base({ language: 'loginRecord' }),
    require('common/mixin/base').base({ reuse: 'reuse' })
]

const computed = {
  tableHead() {
    return this.language.tableHead
  },
}

const created = function() {
    // this.ajaxHandle();
}

const methods = {
    ajaxHandle() {
        const { searchVal, searchKey, validKeys } = this;
        const reg = validKeys[searchKey];
        if(!reg.test(searchVal)) {
            this.$message.warning(this.language.validWarning);
            return;
        }
        this.page.active = 1;
        this.loading = true;
        this.$http.get(URL_LOGIN_RECORD, { params: { searchKey, searchVal } }).then(res => {
            this.allData = res.data.data;
            this.pageHandle();
            this.loading = false;
        }).catch(e => {
            this.tbodyData = [];
            this.loading = false;
            alert(this.reuse.serverError);
        })
    },
    pageHandle() {
        const pageNum = this.page.active
        const pageSize = this.selPage.limit
        this.page.pageLeng = this.allData.length
        this.tbodyData = this.allData.slice((pageNum - 1) * pageSize, pageNum * pageSize)
    },
    export2Excel() {
        const header = this.language.ipTableHead
        require.ensure([], () => {
            const { export_json_to_excel } = require('@/vendor/Export2Excel')
            const tHeader = this.tableHead.map((v) => v.value)
            const filterVal = this.tableHead.map((v) => v.key)
            const data = this.allData.map((v) => filterVal.map((j) => v[j]))
            export_json_to_excel(tHeader, data, this.language.downloadName)
        })
    },
}

const components = {
  customTable
}

export default {
  data,
  mixins,
  computed,
  created,
  methods,
  components,
}
</script>


// WEBPACK FOOTER //
// src/views/record/login-record.vue